'use strict';

// Selectors
const selector = {
  slider: '.js-slider-product-set',
  navigationButtons: '.js-navigation-button'
};

// Elements
const element = {
  slider: document.querySelector(selector.slider) || null,
  navigationButtons: document.querySelectorAll(selector.navigationButtons) || []
};

// Variables
const scrollDistance = 200;

// Functions
const scrollSlider = (direction) => {
  if (element.slider) {
    element.slider.scrollBy({
      left: direction === 'right' ? scrollDistance : -scrollDistance,
      behavior: 'smooth'
    });
  }
};

// Events
document.addEventListener('DOMContentLoaded', function () {
  element.navigationButtons.forEach((button) => {
    button.addEventListener('click', function () {
      const direction = this?.dataset?.direction;
      scrollSlider(direction);
    });
  });
});
